<digital-platform-cards-carousel
  [bgColor]="bgColor"
  [cardsCarouselCard]="cardsCarouselCard"
  [richTextTitle]="richTextTitle"
  [showAccordion]="showAccordian"
></digital-platform-cards-carousel>
